/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import LabelledField from "components/labelled-field";
import { ComponentImageLinkEditWrapper } from "cms/components/components/image-link/edit/component-image-link-wrapper";
import { ImageLinkItemEditor } from "cms/components/components/image-link/edit/list-item";
import { CardsSimpleImage } from "cms/components/components/cards-simple/edit/cards-simple-image";

const HighlightComponentEditor = () => {

    const { component, update, updateFactory } = useUpdateComponent();
    const {
        description,
        image: _image,
        image_links: imageLinks,
        section_name,
        subtitle,
        title
    } = component;
    
    const { t } = useTranslation();
    const [image, setImage] = useState(_image);

    const onChangeSectionName = (event) => {
        const sectionName = event.target.value;
        update("section_name", sectionName);
    };
    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onChangeSubtitle = (event) => {
        const subtitle = event.target.value;
        update("subtitle", subtitle);
    };

    const onChangeDescription = (description) => {
        update("description", description);
    };

    const onChangeImage = (guid) => {
        setImage(guid);
        update("image", guid);
    };

    const onChangeImageLinks = updateFactory("image_links");

    return (
        <div className='simplicity-editor-frame highlight-component-editor'>

            <LabelledField label='Section Name'>
                <TextField
                    fullWidth
                    onChange={onChangeSectionName}
                    placeholder={t("commons.addSectionName")}
                    value={section_name}
                />
            </LabelledField>

            <LabelledField label='Title'>
                <TextField
                    fullWidth
                    onChange={onChangeTitle}
                    placeholder={t("commons.addTitle")}
                    value={title}
                />
            </LabelledField>

            <LabelledField label='Subtitle'>
                <TextField
                    fullWidth
                    onChange={onChangeSubtitle}
                    placeholder={t("commons.addSubtitle")}
                    value={subtitle}
                />
            </LabelledField>

            <LabelledField label='Description'>
                <SimplicityComposerEnsureTipTap
                    onChange={onChangeDescription}
                    richtext={description}
                />
            </LabelledField>

            <LabelledField label='Image'>
                <CardsSimpleImage
                    image={image}
                    updateImage={onChangeImage}
                />
            </LabelledField>

            <div className="image-link-editor-links">
                <ComponentImageLinkEditWrapper list={imageLinks} onChange={onChangeImageLinks}>
                    <ImageLinkItemEditor />
                </ComponentImageLinkEditWrapper>
            </div>

        </div>
    );
};

HighlightComponentEditor.displayName = "HighlightComponentEditor";
export { HighlightComponentEditor };
